import React from 'react';
import classNames from 'classnames';

/*
	Filters for attributes with min and max and a pill UI

	props:
     	ranges - array of numbers e.g. [ 1000, 5000 ]
 	        - if range is dynamic - needs to not be 0,0 on first render - which is taken care of by parent component SearchFilterSqFtData
        id - string, e.g. sq-ft
		options - [1, 2, 3, ...] - shouldn't change
		onChange - function when an option is selected
		activeMin - { isMin: boolean, value: number} - stored in useSearchFilters
		activeMax - { isMax: boolean, value: number} - stored in useSearchFilters
		label - string, e.g. Square Footage

	useNumericMenu wasn't working properly with 2 different attributes, so had to create a custom component
*/
const SearchFiltersNumeric = ( props ) => {
	const { ranges, id, options, onChange, activeMin, activeMax, label } = props;

	return (
		<div>
			<div className='tw-font-bold tw-mb-2'>{label}</div>
			<ul className='tw-list-none tw-flex tw-pl-0 tw-space-x-3'>
				{options.map( ( item ) => {
					const valueAsNumber = item;
					const isAMin = ranges.min.includes( valueAsNumber );
					const isAMax = ranges.max.includes( valueAsNumber );
					const isNotInRange = ! isAMin && ! isAMax;

					const isActive = activeMin === item || activeMax === item;
					const klasses = classNames( {
						'tw-bg-white  tw-border-steel tw-text-charcoal hover:tw-bg-aloe hover:tw-border-steel': ! isActive,
						'tw-bg-melon tw-border-charcoal hover:tw-bg-melon hover:tw-text-charcoal hover:tw-border-charcoal': isActive,
					} );

					return (
						<li className='' key={`${ id }-${ item }`}>
							<label
								className={`gtm-search-filter ${ klasses } tw-cursor-pointer tw-flex tw-border tw-rounded-full tw-px-2 `}
								data-insights-filters={`${ id }:${ item }`}
							>
								<input
									type="radio"
									className="tw-hidden"
									name={id}
									value={item}
									checked={isActive}
									onClick={() => {
										if ( isActive ) {
											onChange( { isMin: null, value: null } );
										}
									}}
									onChange={() => {
										// if it's not in either range, default to min because that is the likely disabled option
										// e.g. selecting 7+ bedrooms, 2+ becomes unavailable in the current ranges but still should be selectable
										onChange( { min: isAMin || isNotInRange ? item : null, max: isAMax ? item : null } );
									}} />
								<span className="tw-ml-1">{item}+</span>
							</label>
						</li>
					);
				} )}
			</ul>
		</div>
	);
};

export default SearchFiltersNumeric;

